/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ThemeDefs from './defs.defs'

const $nsid = 'app.witchsky.theme.colors'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type: 'app.witchsky.theme.colors'
  name: string
  description?: string
  mode: 'light' | 'dark' | l.UnknownString

  /**
   * Theme recommended for the opposite appearance mode.
   */
  recommendedPair?: l.AtUriString
  base: ColorSet
  variants?: Variant[]

  /**
   * Generator metadata requiring special client support. Unsupported union variants may be hidden.
   */
  special?:
    | l.$Typed<ThemeDefs.MaterialYou>
    | l.$Typed<ThemeDefs.Hue>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  updatedAt?: l.DatetimeString
}

export type { Main }

const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 64, maxGraphemes: 48 }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 300, maxGraphemes: 300 }),
    ),
    mode: /*#__PURE__*/ l.string<{ knownValues: ['light', 'dark'] }>(),
    recommendedPair: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    base: /*#__PURE__*/ l.ref<ColorSet>((() => colorSet) as any),
    variants: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<Variant>((() => variant) as any),
        { maxLength: 11 },
      ),
    ),
    special: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ThemeDefs.MaterialYou>(
            (() => ThemeDefs.materialYou) as any,
          ),
          /*#__PURE__*/ l.typedRef<ThemeDefs.Hue>((() => ThemeDefs.hue) as any),
        ],
        false,
      ),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type ColorSet = {
  $type?: 'app.witchsky.theme.colors#colorSet'
  name: string
  colors: SemanticColors
}

export type { ColorSet }

const colorSet = /*#__PURE__*/ l.typedObject<ColorSet>(
  $nsid,
  'colorSet',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 48, maxGraphemes: 32 }),
    colors: /*#__PURE__*/ l.ref<SemanticColors>((() => semanticColors) as any),
  }),
)

export { colorSet }

type Variant = {
  $type?: 'app.witchsky.theme.colors#variant'
  name: string
  colors?: SemanticColorOverrides
}

export type { Variant }

const variant = /*#__PURE__*/ l.typedObject<Variant>(
  $nsid,
  'variant',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 48, maxGraphemes: 32 }),
    colors: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SemanticColorOverrides>(
        (() => semanticColorOverrides) as any,
      ),
    ),
  }),
)

export { variant }

type SemanticColors = {
  $type?: 'app.witchsky.theme.colors#semanticColors'

  /**
   * App background.
   */
  canvas: string

  /**
   * Cards, sheets, and controls.
   */
  surface: string

  /**
   * Menus and elevated surfaces.
   */
  surfaceRaised: string

  /**
   * Primary content text.
   */
  text: string

  /**
   * Secondary labels and metadata.
   */
  textMuted: string

  /**
   * Dividers and control outlines.
   */
  border: string

  /**
   * Links, selected controls, and primary actions.
   */
  accent: string

  /**
   * Subtle selected and accent backgrounds.
   */
  accentSoft: string

  /**
   * Content drawn on the accent color.
   */
  onAccent: string

  /**
   * Success and confirmation states.
   */
  positive: string

  /**
   * Caution states.
   */
  warning: string

  /**
   * Errors and destructive actions.
   */
  critical: string

  /**
   * Like and favorite actions.
   */
  favorite: string
}

export type { SemanticColors }

const semanticColors = /*#__PURE__*/ l.typedObject<SemanticColors>(
  $nsid,
  'semanticColors',
  /*#__PURE__*/ l.object({
    canvas: /*#__PURE__*/ l.string(),
    surface: /*#__PURE__*/ l.string(),
    surfaceRaised: /*#__PURE__*/ l.string(),
    text: /*#__PURE__*/ l.string(),
    textMuted: /*#__PURE__*/ l.string(),
    border: /*#__PURE__*/ l.string(),
    accent: /*#__PURE__*/ l.string(),
    accentSoft: /*#__PURE__*/ l.string(),
    onAccent: /*#__PURE__*/ l.string(),
    positive: /*#__PURE__*/ l.string(),
    warning: /*#__PURE__*/ l.string(),
    critical: /*#__PURE__*/ l.string(),
    favorite: /*#__PURE__*/ l.string(),
  }),
)

export { semanticColors }

type SemanticColorOverrides = {
  $type?: 'app.witchsky.theme.colors#semanticColorOverrides'

  /**
   * App background.
   */
  canvas?: string

  /**
   * Cards, sheets, and controls.
   */
  surface?: string

  /**
   * Menus and elevated surfaces.
   */
  surfaceRaised?: string

  /**
   * Primary content text.
   */
  text?: string

  /**
   * Secondary labels and metadata.
   */
  textMuted?: string

  /**
   * Dividers and control outlines.
   */
  border?: string

  /**
   * Links, selected controls, and primary actions.
   */
  accent?: string

  /**
   * Subtle selected and accent backgrounds.
   */
  accentSoft?: string

  /**
   * Content drawn on the accent color.
   */
  onAccent?: string

  /**
   * Success and confirmation states.
   */
  positive?: string

  /**
   * Caution states.
   */
  warning?: string

  /**
   * Errors and destructive actions.
   */
  critical?: string

  /**
   * Like and favorite actions.
   */
  favorite?: string
}

export type { SemanticColorOverrides }

const semanticColorOverrides =
  /*#__PURE__*/ l.typedObject<SemanticColorOverrides>(
    $nsid,
    'semanticColorOverrides',
    /*#__PURE__*/ l.object({
      canvas: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      surface: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      surfaceRaised: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      text: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      textMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      border: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      accent: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      accentSoft: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      onAccent: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      positive: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      warning: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      critical: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      favorite: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { semanticColorOverrides }
